<div class="cbc-local-file-dialog">
  <div class="has-auto-exchange cbc-local-file-overwrite">
    Has Automatic Exchange: &nbsp;&nbsp;&nbsp; {{hasAutoExchangeValue}}
  </div>
  <div class="surrogate-parent cbc-local-file-overwrite">
    Surrogate Parent: &nbsp;&nbsp;&nbsp; {{surrogateRequired}}
  </div>
  <div class="cbc-local-file-required-default cbc-local-file-overwrite">
    Default Value: &nbsp;&nbsp;&nbsp; {{localEntityRequiredDefaultFile}}
  </div>

  <div class="cbc-local-file-overwrite">
    <mat-checkbox class="example-margin" [(ngModel)]="IsLocalFileRequiredOverwrite">Overwrite</mat-checkbox>
    <mat-radio-group class="overwrite-options" [(ngModel)]="overwrittenValue">
      <mat-radio-button class="overwrite-option-value" [disabled]="!IsLocalFileRequiredOverwrite"  value="Yes">Yes</mat-radio-button>
      <mat-radio-button class="overwrite-option-value" [disabled]="!IsLocalFileRequiredOverwrite"  value="No">No</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
